<template>
  <div>
    <div class="table-navigation">
      <!-- list filter -->
      <div class="list-filter">
        <!-- filter cabang -->
        <div style="margin-right: 12px" class="filter-pilihan">
          <div @click="openClosePilihanCabang(true)" class="filter">
            <!-- tipe filter -->
            <p>Cabang :</p>
            <!-- value filter -->
            <span>{{ filterData.cabang ? filterData.cabang : "Semua" }}</span>
            <!-- icon filter -->
            <svg
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- box pilihan filter -->
          <div
            style="margin-top: 2px; display: none"
            ref="boxPilihanCabang"
            class="box-pilihan"
          >
            <p
              v-for="cabang in listPenempatan"
              :key="cabang"
              @click="openClosePilihanCabang(false, cabang)"
              style="border-top: 1px solid #ebeff2"
            >
              {{ cabang }}
              <svg
                v-if="cabang === filterData.cabang"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan filter -->
        </div>

        <!-- end of filter cabang -->

        <!-- filter Divisi-->
        <div style="margin-right: 12px" class="filter-pilihan">
          <div @click="openClosePilihanDivisi(true)" class="filter">
            <!-- tipe filter -->
            <p>Divisi :</p>
            <!-- value filter -->
            <span>{{ filterData.divisi }}</span>
            <!-- icon filter -->
            <svg
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- box pilihan filter -->
          <div
            style="margin-top: 2px; display: none"
            ref="boxPilihanDivisi"
            class="box-pilihan"
          >
            <p
              @click="openClosePilihanDivisi(false, divisi)"
              :key="divisi"
              v-for="divisi in listDivisi"
            >
              {{ divisi }}
              <svg
                v-if="divisi === filterData.divisi"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan filter -->
        </div>
        <!-- end of filter Divisi-->

        <!-- filter Status-->
        <div class="filter-pilihan">
          <div @click="openClosePilihanStatus(true)" class="filter">
            <!-- tipe filter -->
            <p>Status :</p>
            <!-- value filter -->
            <span>{{ filterData.status }}</span>
            <!-- icon filter -->
            <svg
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- box pilihan filter -->
          <div
            style="margin-top: 2px; display: none"
            ref="boxPilihanStatus"
            class="box-pilihan"
          >
            <p
              :key="status"
              v-for="status in listStatusKepegawaian"
              @click="openClosePilihanStatus(false, status)"
            >
              {{ status }}
              <svg
                v-if="status === filterData.status"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan filter -->
        </div>
        <!-- end of filter Status-->
      </div>
      <!-- end of list filter -->

      <!-- bagian untuk cari tambah dan download -->
      <div class="cari-tambah-download">
        <!-- box pencarian -->
        <div class="cari">
          <svg
            style="margin-right: 8px"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.4286 13.4294L10.3214 10.3223M12 6.28655C12 9.44246 9.44161 12.0008 6.2857 12.0008C3.12978 12.0008 0.571411 9.44246 0.571411 6.28655C0.571411 3.13064 3.12978 0.572266 6.2857 0.572266C9.44161 0.572266 12 3.13064 12 6.28655Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <input
            v-model="filterData.pencarian"
            placeholder="Cari"
            type="text"
            name=""
            id=""
          />
        </div>

        <!-- button download -->
        <button @click="downloadData" class="download">
          <svg
            width="16"
            height="16"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.4286 9.14375V12.0009C13.4286 12.3798 13.278 12.7431 13.0101 13.011C12.7422 13.279 12.3789 13.4295 12 13.4295H1.99998C1.6211 13.4295 1.25774 13.279 0.98983 13.011C0.721921 12.7431 0.571411 12.3798 0.571411 12.0009V9.14375M3.42855 5.57227L6.99998 9.14369M6.99998 9.14369L10.5714 5.57227M6.99998 9.14369V0.572266"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <!-- open menu mobile -->
        <div class="open-menu-mobile">
          <!-- menu icon -->
          <svg
            @click="openCloseMenuMobile(true)"
            width="14"
            height="4"
            viewBox="0 0 14 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.99993 2.71422C7.39442 2.71422 7.71422 2.39442 7.71422 1.99993C7.71422 1.60544 7.39442 1.28564 6.99993 1.28564C6.60544 1.28564 6.28564 1.60544 6.28564 1.99993C6.28564 2.39442 6.60544 2.71422 6.99993 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.9999 2.71422C12.3944 2.71422 12.7142 2.39442 12.7142 1.99993C12.7142 1.60544 12.3944 1.28564 11.9999 1.28564C11.6054 1.28564 11.2856 1.60544 11.2856 1.99993C11.2856 2.39442 11.6054 2.71422 11.9999 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.99993 2.71422C2.39442 2.71422 2.71422 2.39442 2.71422 1.99993C2.71422 1.60544 2.39442 1.28564 1.99993 1.28564C1.60544 1.28564 1.28564 1.60544 1.28564 1.99993C1.28564 2.39442 1.60544 2.71422 1.99993 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <!-- end of menu icon -->

          <div
            style="display: none"
            ref="box-pilihan-menu"
            class="box-pilihan-aksi"
          >
            <!-- buka menu filter -->
            <p @click="openCloseFilterMobile(true)">
              <svg
                width="17"
                height="15"
                viewBox="0 0 17 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.2437 0.571289H1.04053L7.12179 7.32843V12.7141L10.1624 14.1427V7.32843L16.2437 0.571289Z"
                  stroke="#4E4B66"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Filter
            </p>

            <!-- melakukan downlaod -->
            <p @click="downloadData">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4287 9.14277V11.9999C13.4287 12.3788 13.2782 12.7422 13.0103 13.0101C12.7423 13.278 12.379 13.4285 12.0001 13.4285H2.0001C1.62122 13.4285 1.25786 13.278 0.989952 13.0101C0.722043 12.7422 0.571533 12.3788 0.571533 11.9999V9.14277M3.42868 5.57129L7.0001 9.14272M7.0001 9.14272L10.5715 5.57129M7.0001 9.14272V0.571289"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Download
            </p>
          </div>
        </div>
        <!-- end of open menu mobile -->
      </div>
    </div>
    <!-- end of bagian untuk cari tambah dan download -->

    <!-- filter mobile -->
    <div style="bottom: -100%" ref="filter-mobile" class="backdrop">
      <div class="filter-mobile">
        <div class="filter-mobile-title">
          <h5>
            Filter <br />
            Data karyawan
          </h5>
          <!-- close filter -->
          <svg
            @click="openCloseFilterMobile(false)"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.28566 0.714355L0.714233 9.28578M0.714233 0.714355L9.28566 9.28578"
              stroke="#1A1A1A"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <!-- input cabang -->
        <div class="keterangan input-keterangan">
          <div
            @click="openClosePilihanCabangMobile(true)"
            ref="keterangan-form"
            class="box-form email"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.857178 11.5712L8.00003 15.1426L15.1429 11.5712M0.857178 7.99979L8.00003 11.5712L15.1429 7.99979M8.00003 0.856934L0.857178 4.42836L8.00003 7.99979L15.1429 4.42836L8.00003 0.856934Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterData.cabang"
                style="display: block"
                class="input-title"
                >Cabang</span
              >
              <p>
                {{ filterData.cabang ? filterData.cabang : "Cabang" }}
              </p>
            </div>
          </div>
          <!-- box pilihan cabang -->
          <div
            style="display: none"
            ref="boxPilihanCabangMobile"
            class="box-pilihan"
          >
            <p
              @click="openClosePilihanCabangMobile(false, cabang)"
              v-for="cabang in listPenempatan"
              :key="cabang"
            >
              {{ cabang }}
              <svg
                v-if="cabang === filterData.cabang"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan cabang-->
        </div>
        <!-- end of input cabang -->

        <!-- input divisi -->
        <div class="keterangan input-keterangan">
          <div
            @click="openClosePilihanDivisiMobile(true)"
            ref="keterangan-form"
            class="box-form email"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.857178 11.5712L8.00003 15.1426L15.1429 11.5712M0.857178 7.99979L8.00003 11.5712L15.1429 7.99979M8.00003 0.856934L0.857178 4.42836L8.00003 7.99979L15.1429 4.42836L8.00003 0.856934Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterData.divisi"
                style="display: block"
                class="input-title"
                >Divisi</span
              >
              <p>
                {{ filterData.divisi ? filterData.divisi : "Divisi" }}
              </p>
            </div>
          </div>
          <!-- box pilihan divisi -->
          <div
            style="display: none"
            ref="boxPilihanDivisiMobile"
            class="box-pilihan"
          >
            <p
              @click="openClosePilihanDivisiMobile(false, divisi)"
              v-for="divisi in listDivisi"
              :key="divisi"
            >
              {{ divisi }}
              <svg
                v-if="divisi === filterData.divisi"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan divisi -->
        </div>
        <!-- end of input divisi -->

        <!-- input status -->
        <div class="keterangan input-keterangan">
          <div
            @click="openClosePilihanStatusMobile(true)"
            ref="keterangan-form"
            class="box-form email"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.857178 11.5712L8.00003 15.1426L15.1429 11.5712M0.857178 7.99979L8.00003 11.5712L15.1429 7.99979M8.00003 0.856934L0.857178 4.42836L8.00003 7.99979L15.1429 4.42836L8.00003 0.856934Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span
                v-if="filterData.status"
                style="display: block"
                class="input-title"
                >Status</span
              >
              <p>
                {{ filterData.status ? filterData.status : "Status" }}
              </p>
            </div>
          </div>
          <!-- box pilihan status -->
          <div
            style="display: none"
            ref="boxPilihanStatusMobile"
            class="box-pilihan"
          >
            <p
              @click="openClosePilihanStatusMobile(false, status)"
              v-for="status in listStatusKepegawaian"
              :key="status"
            >
              {{ status }}
              <svg
                v-if="status === filterData.status"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                  stroke="#00BA88"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </p>
          </div>
          <!-- end of box pilihan status -->
        </div>

        <!-- end of input status -->

        <div class="button-container">
          <button @click="openCloseFilterMobile(false)" class="yellow-button">
            Terapkan
          </button>
        </div>
      </div>
    </div>
    <!-- end of filter mobile -->

    <!-- tabel -->
    <div class="box-table">
      <table>
        <!-- judul tabel  -->
        <tr>
          <th style="width: 26%">Nama Karyawan</th>
          <th>Cabang</th>
          <th>No HP</th>
          <th>Status</th>
        </tr>
        <!-- start iterasi tabel -->

        <tr :key="karyawan.docId" v-for="karyawan in listKaryawanFiltered">
          <!-- Nama Karyawan, divisi, dan cabang  -->
          <td>
            <span style="color: #1d1d1d; font-weight: 700">
              {{ karyawan.data.dataDiri.namaLengkap }}
            </span>
            <br>
            {{ karyawan.data.dataKepegawaian.jabatan }}-{{
              karyawan.data.dataKepegawaian.divisi
            }}
          </td>
          <!-- Cabang  -->
          <td>{{ karyawan.data.dataKepegawaian.cabang }}</td>
          <!-- no hp  -->
          <td>{{ karyawan.data.dataDiri.noHp }}</td>
          <!-- Status absen -->
          <td
            v-if="karyawan.data.dataKepegawaian.status === 'nonAktif'"
            class="tipe-absen"
          >
            <span>Non-aktif</span>
          </td>
          <!-- Status cuti -->
          <td
            v-if="karyawan.data.dataKepegawaian.status === 'cuti'"
            class="tipe-cuti"
          >
            <span>Cuti</span>
          </td>
          <!-- Status absen -->
          <td
            v-if="karyawan.data.dataKepegawaian.status === 'absen'"
            class="tipe-cuti"
          >
            <span>Absen</span>
          </td>
          <!-- Status full time -->
          <td
            v-if="karyawan.data.dataKepegawaian.status === 'fullTime'"
            class="tipe-presensi"
          >
            <span>Full time</span>
          </td>
          <!-- status partime -->
          <td
            v-if="karyawan.data.dataKepegawaian.status === 'partTime'"
            class="tipe-presensi"
          >
            <span>Part time</span>
          </td>
        </tr>
        <!-- end iterasi tabel -->
      </table>

      <p
        v-if="!listKaryawanFiltered || listKaryawanFiltered.length === 0"
        class="empty-state-table"
      >
        Belum ada data
      </p>
    </div>
    <!-- end of tabel -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import XLSX from "xlsx";

export default {
  data() {
    return {
      // variabel untuk filter
      filterData: {
        divisi: "semua",
        cabang: "",
        status: "semua",
        pencarian: "",
      },
    };
  },

  methods: {
    // untuk tutup atau buka box filter Divisi
    openClosePilihanDivisi(open, value) {
      let box = this.$refs.boxPilihanDivisi;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.divisi = value;
      }
    },

    openClosePilihanDivisiMobile(open, value) {
      let box = this.$refs.boxPilihanDivisiMobile;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.divisi = value;
      }
    },

    openClosePilihanCabang(open, value) {
      let box = this.$refs.boxPilihanCabang;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.cabang = value;
      }
    },

    openClosePilihanCabangMobile(open, value) {
      let box = this.$refs.boxPilihanCabangMobile;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.cabang = value;
      }
    },

    openClosePilihanStatusMobile(open, value) {
      let box = this.$refs.boxPilihanStatusMobile;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.status = value;
      }
    },

    // untuk tutup atau buka box filter status
    openClosePilihanStatus(open, value) {
      let box = this.$refs.boxPilihanStatus;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.status = value;
      }
    },

    openCloseMenuMobile(isOpen) {
      let box = this.$refs["box-pilihan-menu"];
      if (isOpen) box.style.display = "block";
      else box.style.display = "none";
    },

    openCloseFilterMobile(isOpen) {
      this.openCloseMenuMobile(false);
      let box = this.$refs["filter-mobile"];
      if (isOpen) box.style.bottom = "0px";
      else box.style.bottom = "-100%";
    },

    downloadData() {
      this.openCloseMenuMobile(false);
      let dataKaryawan = [];
      this.listKaryawanFiltered.forEach((karyawan) => {
        dataKaryawan.push({
          nama: karyawan.data.dataDiri.namaLengkap,
          jabatan: karyawan.data.dataKepegawaian.jabatan,
          divisi: karyawan.data.dataKepegawaian.divisi,
          cabang: karyawan.data.dataKepegawaian.cabang,
          status: karyawan.data.dataKepegawaian.status,
        });
      });
      const data = XLSX.utils.json_to_sheet(dataKaryawan);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "data_karyawan.xlsx");
    },
  },

  computed: {
    ...mapState([
      "listDivisi",
      "listStatusKepegawaian",
      "listKaryawan",
      "listPenempatan",
      "userData",
    ]),

    listKaryawanFiltered() {
      let karyawan = this.listKaryawan.filter((item) => item.data.dataDiri);
      let filterDivisi = this.filterData.divisi;
      let filterCabang = this.filterData.cabang;
      let filterPencarian = this.filterData.pencarian.toLowerCase();
      let filterStatus = this.filterData.status;

      if (filterDivisi === "semua") filterDivisi = "";
      if (filterCabang === "Semua") filterCabang = "";
      if (filterStatus === "semua") filterStatus = "";
      console.log(karyawan);
      return karyawan.filter(function (item) {
        let filtered = true;
        if (filterDivisi && filterDivisi.length > 0) {
          filtered = item.data.dataKepegawaian.divisi == filterDivisi;
        }

        if (filtered) {
          if (filterCabang && filterCabang.length > 0) {
            filtered = item.data.dataKepegawaian.cabang == filterCabang;
          }
        }

        if (filtered) {
          if (filterPencarian && filterPencarian.length > 0) {
            filtered = item.data.dataDiri.namaLengkap
              .toLowerCase()
              .includes(filterPencarian);
          }
        }
        if (filtered) {
          if (filterStatus && filterStatus.length > 0) {
            filtered = item.data.dataKepegawaian.status == filterStatus;
          }
        }
        return filtered;
      });
    },
  },
};
</script>
<style scoped>
.failed-box-form {
  border-color: #eb5757;
}

.failed-box-form * {
  color: #eb5757;
  stroke: #eb5757;
}
</style>
